const appointmentSummaryState = {
  data: [],
  loading: false,
  error: null,
};
const appointmentState = {
  data: [],
  loading: false,
  error: null,
};

const pastAppointmentState = {
  data: [],
  loading: false,
  error: null,
};

const quickState = {
  data: {},
  loading: false,
  error: null,
};

const deliveryTrendState = {
  data: {},
  loading: false,
  error: null,
};

const riskStatusState = {
  data: {},
  loading: false,
  error: null,
};

const userDataState = {
  user: {},
  userLoading: false,
  userError: null,
};

const countryState = {
  country: [],
  countryLoading: false,
  countryError: null,
};

const stateState = {
  state: [],
  stateLoading: false,
  stateError: null,
};

const cityState = {
  city: [],
  cityLoading: false,
  cityError: null,
};

const languageState = {
  language: [],
  languageLoading: false,
  languageError: null,
};

const updateProfileState = {
  data: null,
  loading: false,
  error: null,
};

const appointmentCounter = {
  data: [],
  loading: false,
  error: null,
};

const practitionerSlots = {
  data: {},
  loading: false,
  error: null,
};

const createSlotState = {
  slotData: null,
  slotLoading: false,
  sloatError: null,
};

const updateSlotState = {
  updateSlotData: null,
  updateSlotLoading: false,
  updateSlotError: null,
};

const createUnavailable = {
  data: null,
  loading: false,
  error: null,
};

const unavailableRange = {
  range: [],
  rangeLoading: false,
  rangeError: null,
};

const unavailableAppointment = {
  data: [],
  loading: false,
  error: null,
};

const editUnavailable = {
  editData: null,
  loading: false,
  errorEdit: null,
};

const deleteUnavailable = {
  deleteData: null,
  loading: false,
  errorDelete: null,
};

const appointmentDetail = {
  detail: null,
  detailLoading: false,
  detailError: null,
};

const deleteScheduleState = {
  deleteScheduleData: null,
  deleteScheduleLoading: false,
  deleteScheduleError: null,
};

const deletAllSlotState = {
  deleteAllData: null,
  deleteAllLoading: false,
  deleteAllError: null,
};

const deletAllUnavailableState = {
  deleteAllUnData: null,
  deleteAllUnLoading: false,
  deleteAllUnError: null,
};

const rescheduleStatus = {
  rescheduleData: null,
  rescheduleLoading: false,
  rescheduleError: null,
};

const availableSlotState = {
  data: {},
  loading: false,
  error: null,
};

const createAppointmentState = {
  data: null,
  loading: false,
  error: null,
};

const followUpAppointmentState = {
  data: [],
  loading: false,
  error: null,
};

const followUpAppointmentCounterState = {
  data: [],
  loading: false,
  error: null,
};

export {
  appointmentSummaryState,
  appointmentState,
  quickState,
  deliveryTrendState,
  riskStatusState,
  pastAppointmentState,
  userDataState,
  countryState,
  stateState,
  cityState,
  languageState,
  updateProfileState,
  appointmentCounter,
  practitionerSlots,
  createSlotState,
  updateSlotState,
  createUnavailable,
  unavailableRange,
  unavailableAppointment,
  editUnavailable,
  deleteUnavailable,
  appointmentDetail,
  deleteScheduleState,
  deletAllSlotState,
  deletAllUnavailableState,
  rescheduleStatus,
  availableSlotState,
  createAppointmentState,
  followUpAppointmentState,
  followUpAppointmentCounterState,
};
